import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner';
import { useNavigate, useParams } from 'react-router-dom';

const UpdateAdmin = () => {
  
  const { id } = useParams()
  const [first_name, setFirst_name] = useState('');
  const [last_name, setLast_name] = useState('');
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // getting user
  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios.get(`/users/${id}`)
        setFirst_name(response.data.first_name)
        setLast_name(response.data.last_name)
        setRole(response.data.role)
      } catch (error) {
        console.log(error)
      }
    }
    getUser()
  },[id])


  // update  admin
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`/users/${id}`,
        { first_name, last_name, role }
      );
      toast.success('Admin updated successfully!');
      navigate('/admins');
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else {
        toast.error('Error updating admin.');
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  return (
    <div className='mx-auto p-4 flex justify-center'>
      <div className='p-4 bg-white rounded-lg w-full lg:w-full xl:w-1/2'>
        <h3 className='text-xl text-center font-bold text-[#134463]'>Update Admin.</h3>
        <form onSubmit={handleSubmit}>
          <div className='mt-2'>
            <label htmlFor='firstname'>First Name
              <input
                type='text'
                placeholder='First Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='lastname'>Last Name
              <input
                type='text'
                placeholder='Last Names'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <label htmlFor='role'>User Role
              <select
                first_name='role' id='role'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                required
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value=''>Choose Role</option>
                <option value='SYSTEM_ADMIN'>System Admin</option>
                <option value='ADMIN'>Admin</option>
                <option value='FINANCE'>Finance</option>
                <option value='ONFON_SUPPORT'>Onfon Support</option>
              </select>
            </label>
          </div>
          <div className='py-3'>
            <button type='submit' disabled={loading} className='bg-[#2b1e3e] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>{loading ? 'Please wait...' : 'Update Admin'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateAdmin;
